import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var PlayIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M5.403 3.166a1.825 1.825 0 0 1 1.733.114l11.665 7.5c.217.138.393.321.514.534.122.212.185.447.185.686 0 .239-.063.474-.185.687a1.558 1.558 0 0 1-.514.534L7.137 20.72a1.824 1.824 0 0 1-1.732.114 1.611 1.611 0 0 1-.66-.553 1.39 1.39 0 0 1-.244-.782V4.501c0-.276.084-.546.243-.781a1.61 1.61 0 0 1 .66-.554Z"
        })
    }));
};
